import { Event, EventType } from "./Event";

import type { IAddPageViewEvent } from "./types";

export class AddPageViewEvent extends Event {
  constructor({ page, tracking, customEventProperties }: IAddPageViewEvent) {
    super({
      event_type: EventType.page_view,
      event_properties: { page, tracking },
      custom_event_properties: customEventProperties,
    });
  }
}
